module.exports = __webpack_public_path__ + "static/2019426:2ace0725733a716000c6/img/threePhones_3x.363255e.png";


//////////////////
// WEBPACK FOOTER
// ./app/src/assets/images/threePhones_3x.png
// module id = yXy9
// module chunks = 41